import Vue from 'vue'

// reactive on purpose: libs/support-badge.js sets `tag` to the number of messages waiting for review
export const supportNavItem = Vue.observable({
  title: 'Support',
  route: 'support',
  icon: 'LifeBuoyIcon',
  tag: '',
  tagVariant: 'light-warning',
})

export default [
  {
    title: 'Accounts',
    route: 'accounts',
    icon: 'UsersIcon',
  },
  {
    title: 'Purchases',
    route: 'purchases',
    icon: 'ShoppingCartIcon',
  },
  {
    title: 'Devices',
    route: 'devices',
    icon: 'CpuIcon',
  },
  {
    title: 'Books',
    route: 'books',
    icon: 'BookIcon',
  },
  {
    title: 'Reviews',
    route: 'reviews',
    icon: 'StarIcon',
  },
  {
    title: 'ChessPub Books',
    route: 'cpbooks',
    icon: 'BookIcon',
  },
  {
    title: 'Puzzles',
    route: 'puzzles',
    icon: 'BarChartIcon',
  },
  {
    title: 'Notifications',
    route: 'notifications',
    icon: 'BellIcon',
  },
  {
    title: 'Settings',
    route: 'settings',
    icon: 'SettingsIcon',
  },
  supportNavItem,
]
